export var uppercase = function (value) { return value.toUpperCase(); };
//# sourceMappingURL=uppercase.js.map